export const overlayBreakpointMap: { [key: string]: number } = {
  menuOverlay: 1250,
  sidebarOverlay: 1024,
}
